<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" :class="classObj" class="app-wrapper">
    <navbar v-show="!fullScreenType" />
    <div v-if="device==='mobile'&&sidebar.opened" v-show="!fullScreenType" class="drawer-bg" @click="handleClickOutside" />
    <sidebar v-show="!fullScreenType" class="sidebar-container" />
    <el-dialog
      custom-class="xigua-player"
      :visible="$store.getters.xiGuaPlayer.playerDialog"
      :title="$store.getters.xiGuaPlayer.title"
      :width="$global.isPC ? '60%' : '90%'"
      :before-close="()=>{$store.dispatch('xiGuaPlayer/pause')}"
      :close-on-click-modal="true"
      :append-to-body="true"
      top="10vh"
    >
      <div />
      <template #footer>
        <div id="xigua-play" />
      </template>
    </el-dialog>
    <div class="main-container">
      <div v-show="!fullScreenType" :class="{'fixed-header':fixedHeader}">
        <tags-view />
      </div>
      <app-main ref="appMain" :class="{'full-screen-view':fullScreenType}" />
    </div>

    <warning-message :data="messageData" />
    <ResetLogin />
    <FloatingBall v-if="floatingBallVisble" />
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView, FloatingBall } from './components'
import warningMessage from './warningMessage'
import ResetLogin from './ResetLogin'
import ResizeMixin from './mixin/ResizeHandler'
import { toFixed, parseTime } from '@/utils'
const Base64 = require('js-base64').Base64
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    warningMessage,
    ResetLogin,
    FloatingBall
  },
  mixins: [ResizeMixin],
  data() {
    return {
      warningShow: false,
      warningIndex: 0,
      tableHeight: '500px',
      fullscreenLoading: false,
      messageData: {},
      fullScreenType: false
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    floatingBallVisble() {
      const visibleModel = ['dsp', 'dms', 'admin', 'guide']
      const model = this.$route.path.split('/')[1]
      return visibleModel.includes(model)
    }
  },
  watch: {
    '$store.getters.ws_message': function(response) {
      const data = response.data
      if (data.notice_type === 5) {
        this.messageData = data
      } else if (data.notice_type === 7) {
        this.logout() // 用户被删除，强制退出
      }
    }
  },
  created() {
    const state = localStorage.getItem('menuDefaultState') || 'close' // 获取个人中心设置
    if (state === 'open') {
      this.$store.dispatch('app/openSideBar', { withoutAnimation: false })
    } else if (state === 'close') {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
    this.$store.dispatch('websocket/init')
    this.keyupWatch()
    this.watchFullScreen()
    const platformMap = Base64.decode(this.$store.getters.platform_map)
    this.$global.platformMap = JSON.parse(platformMap)
    if (this.$store.getters.plat_map) {
      const platMap = JSON.parse(Base64.decode(this.$store.getters.plat_map))
      this.$global.platIdMap = Object.keys(platMap).map(key => { return { label: platMap[key], value: Number(key) } })
    }
  },
  methods: {
    toFixed,
    parseTime,
    keyupWatch() {
      document.addEventListener('keydown', (e) => {
        const key = e.which || e.keyCode
        this.keyCode += key + ''
        setTimeout(() => {
          if (this.keyCode.indexOf('1766') === -1) {
            this.keyCode = ''
          }
        }, 500)
        if (this.keyCode.indexOf('1766') > -1) {
          this.fullScreen()
          this.keyCode = ''
        }
      })
    },
    watchFullScreen() {
      document.addEventListener('fullscreenchange', () => {
        this.fullScreenType = document.fullscreen
      })
      document.addEventListener('mozfullscreenchange', () => {
        this.fullScreenType = document.mozFullScreen
      })
      document.addEventListener('webkitfullscreenchange', () => {
        this.fullScreenType = document.webkitIsFullScreen
      })
      document.addEventListener('msfullscreenchange', () => {
        this.fullScreenType = document.msFullscreenElement
      })
    },
    fullScreen() {
      this.fullScreenLoading = true
      const dom = document.body
      if (dom) {
        try {
          if (dom.requestFullscreen) {
            dom.requestFullscreen()
          } else if (dom.webkitRequestFullScreen) {
            dom.webkitRequestFullScreen()
          } else if (dom.mozRequestFullScreen) {
            dom.mozRequestFullScreen()
          } else if (dom.msRequestFullscreen) {
          // IE11
            dom.msRequestFullscreen()
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },

    async logout() {
      this.fullscreenLoading = true

      await this.$store.dispatch('websocket/close')

      await this.$store.dispatch('user/logout')
      // 删除缓存的标签
      await this.$store.dispatch('tagsView/delAllViews')

      this.fullscreenLoading = false

      this.$router.push(`/login`)
      location.reload(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
@media (max-height: 1000px) and (max-width: 1000px){
  .navbar{
    position: relative;
  }
  .main-container{
    padding-top: 0!important;
    min-height: calc(100vh - 84px)!important;
  }
}

>>> .xigua-player {
  .el-dialog__body {
    display: none;
  }
}
</style>
